export default {
  duration: {
    short: 4000,
    medium: 8000,
    long: 12000,
    permanent: 300000,
  },
};
